import ReactPDF, { pdf } from '@react-pdf/renderer'
import useSession from 'components/auth/useSession'
import { PromiseErrorContextValue } from 'components/error'
import { useServerTime } from 'hooks/useServerTime'
import React from 'react'

import { PecPrintPageLayout, PecPrintPageLayoutProps } from './layout/PecPrintPageLayout'
import { PrinterType } from './model'

interface PrintDocumentBody extends Omit<PecPrintPageLayoutProps, 'serverTime'> {
  docBody: React.ReactElement
}

export const usePrinter = (session?: PrinterType) => {
  const { data } = useSession({ fetchPolicy: 'cache-only' })
  const { getServerTimeNow } = useServerTime()

  const printPDF = (documentBody: PrintDocumentBody, handleRejection: PromiseErrorContextValue) => {
    const document = renderDocument(documentBody, session ?? data, data.profissional.nome, getServerTimeNow())

    const pdfWindow = window.open(
      '',
      '',
      'width=' + window.screen.width * 0.8 + ', height=' + window.screen.height * 0.8
    )
    pdf(document)
      .toBlob()
      .then((blob) => {
        convertPdf(blob, pdfWindow)
        pdfWindow.focus()
      })
      .catch((error) => {
        handleRejection(error)
        pdfWindow.close()
      })
  }
  return { printPDF }
}

const renderDocument = (
  documentBody: PrintDocumentBody,
  session: PrinterType,
  nameFooter: string,
  serverTime: Date
): React.ReactElement<ReactPDF.DocumentProps> => {
  const { docBody, ...rest } = documentBody
  return (
    <PecPrintPageLayout session={session} nameFooter={nameFooter} serverTime={serverTime} {...rest}>
      {docBody}
    </PecPrintPageLayout>
  )
}

const convertPdf = (blob: Blob, window: Window) => {
  const url = URL.createObjectURL(blob)
  window.document.write("<iframe width='100%' height='100%' frameborder='0' src='" + url + "'></iframe>")
  URL.revokeObjectURL(url)
}
